import { mediaObjectSchema } from '../../../../../src/media.util';
import z from 'zod';
import { cellCfgAttrsBaseSchema, cellCfgBaseSchema } from './cell-base.zod';
import { workInstructionAnnotationSchema } from '../../../../work-instruction-version';

export const varMediaObject = z.object({
    type: z.literal('varForExternal'),
    varId: z.string().min(1),
});

export type VarMediaObject = z.infer<typeof varMediaObject>;

// FUTURE: if other applet things end up using this, move it.
const appletMediaItemSchema = z.discriminatedUnion('type', [
    ...mediaObjectSchema.options,
    varMediaObject,
]);

export const mediaCellSchema = cellCfgBaseSchema.extend({
    type: z.literal('media'),
    attrs: cellCfgAttrsBaseSchema.extend({
        items: z.array(z.object({
            id: z.string(),
            media: appletMediaItemSchema,
            /** seconds */
            timeout: z.number().optional(),
            caption: z.string().optional(),
            annotations: z.array(workInstructionAnnotationSchema).nullable().default(null),
            /** Id of the variable that will set whether the image is shown or not */
            varId: z.string()
                .min(1)
                .nullable()
                .catch(null),
        })),
    }),
});
